import React from "react";
import {IScope} from "@src/Components/Pages/Main/Content/ApplicationsPage/Interfaces/interfaces";
import {Divider} from "@material-ui/core";
import {Values} from "Tools/Values";
import {AppInfoContainer, DetailsValueItalic, DetailTitle, DetailValue} from "../styles";

interface IProps {
    scopes: IScope[]
}

export const InternalAppDetailsScopes = ({scopes}: IProps) => (
    <AppInfoContainer>
        <DetailTitle>{Values.getLocalizationValue('scopes')}</DetailTitle>

        {scopes.map(scope => (
            <div key={scope.id}>
                <Divider/>
                <DetailValue>{scope.friendlyName}</DetailValue>
            </div>
        ))}

        {scopes.length === 0 && (
            <>
                <Divider/>

                <DetailsValueItalic>
                    {Values.getLocalizationValue("thereAreNoItems")}
                </DetailsValueItalic>
            </>
        )}
    </AppInfoContainer>
)
